<template>
  <b-container class="card-container">
    <!-- <b-card v-if="current_item"> -->
      <b-row v-if="current_item">
        <b-col>
          <b-card no-body >
          <video  :src="current_item.video_url" autoplay style="border-top-left-radius: 6px; border-top-right-radius: 6px; background-color: black;" controls/>
          <div class='p-4'>
            <b-button variant='danger' class='mr-2' @click="update_qc_status('bin')">Bin</b-button>
            <b-button variant='warning' class='mr-2' @click="update_qc_status('fail')">Fail</b-button>
            <b-button variant='success' @click="update_qc_status('pass')">Pass</b-button>
          </div>

          </b-card>
        </b-col>
        <b-col>
          <b-card>
          <p>Created: {{current_item.created | datetime}}</p>
          <p>{{current_item.name}}</p>
          <b-button :to='{name: "project", params: {id: current_item.project_id}}' target='_blank' size='sm' class='mr-2'>Project</b-button>
          <b-button :to='{name: "item", params: {id: current_item.project_id, item: current_item.id}}' target='_blank' size='sm' class='mr-2'>Item</b-button>
          <b-button :to='{name: "voice", params: {id: current_item.voice_id}}' target='_blank' size='sm'>Clone</b-button>

          <div class='mt-2'>
            <b-table-simple responsive bordered>
              <b-thead head-variant="light">
                <b-tr>
                  <b-th>Variable</b-th>
                  <b-th>Replace with</b-th>
                </b-tr>
              </b-thead>
              <b-tr v-for="(variable, index) in current_item.variables" v-bind:key="index">
                <b-td>{{variable.word}}</b-td>
                <b-td>{{variable.replace_with}}</b-td>
              </b-tr>
            </b-table-simple>
            <p v-if='current_item.website'>{{current_item.website}}</p>
          </div>
          </b-card>
        </b-col>
      </b-row>
    <b-card v-else class='text-center'>
      <p class='text-center'>The queue is empty</p>
      <LoadingButton :loading="loading_queue" @click="load_queue()">Refresh ({{queue_waiting.length}} waiting)</LoadingButton>
    </b-card>

    <h4 v-if="current_item">Queue</h4>
    <b-card no-body v-if="current_item">
      <b-table :items="table_queue" :fields="['name', 'user', 'project', 'created', 'QC_status', 'QC_count']">
        <template v-slot:cell(user)='data'>
          <a target="_blank" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fuser~2F${data.item.id}`">{{data.item.email}}</a>
        </template>
        <template v-slot:cell(name)='data'>
          <b-link :to="{name: 'item', params: {id: data.item.project_id, item: data.item.id}}" target="_blank">{{data.item.name}}</b-link>
        </template>
        <template v-slot:cell(project)='data'>
          <b-link :to="{name: 'project', params: {id: data.item.project_id}}" target="_blank">{{data.item.project_name}}</b-link>
        </template>
        <template v-slot:cell(QC_status)='data'>
          <span>{{data.item.quality_control_status}}</span>
        </template>
        <template v-slot:cell(QC_count)='data'>
          <span>{{data.item.quality_control_review_count}}</span>
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
      </b-table>
    </b-card>

    <h4>Failed QC</h4>
    <b-card no-body>
      <b-table show-empty :items="fail" :fields="['name', 'user', 'project', 'created', 'QC_status', 'QC_count']">
        <template v-slot:cell(user)='data'>
          <a target="_blank" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fuser~2F${data.item.id}`">{{data.item.email}}</a>
        </template>
        <template v-slot:cell(name)='data'>
          <b-link :to="{name: 'item', params: {id: data.item.project_id, item: data.item.id}}" target="_blank">{{data.item.name}}</b-link>
        </template>
        <template v-slot:cell(project)='data'>
          <b-link :to="{name: 'project', params: {id: data.item.project_id}}" target="_blank">{{data.item.project_name}}</b-link>
        </template>
        <template v-slot:cell(QC_status)='data'>
          <span>{{data.item.quality_control_status}}</span>
        </template>
        <template v-slot:cell(QC_count)='data'>
          <span>{{data.item.quality_control_review_count}}</span>
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
      </b-table>
    </b-card>

  </b-container>
</template>

<script>

import { db, FieldValue } from '@/main.js'
import api from '@/lib/api.js'
import constants from '@/lib/constants.js'
import PlayerItem from '@/components/PlayerItem.vue'

export default {
  metaInfo: {title: 'Quality Control'},
  props: ['profile'],
  firestore: function () {

    let query = db.collectionGroup('item').where('quality_control_status', '==', 'review')
    if (this.profile.role === 'admin') {
      // pass
    } else if (this.profile.team_role.role === constants.team_role.admin || this.profile.team_role.role === constants.team_role.manager) {
      query = query.where('team', '==', db.collection('team').doc(this.profile.team.id))
    } else {
      query = query.where('user', '==', db.collection('user').doc(this.profile.id))
    }

    return {
      queue_waiting: query.orderBy('quality_control_updated', 'desc').limit(100),
    }
  },
  data() {
    return {
      current_index: 0,
      review: [],
      fail: [],
      loading_queue: false,
      queue_waiting: []
    }
  },
  mounted() {
    this.load_queue()
    this.load_queue('fail')
  },
  methods: {
    async update_qc_status(status) {

      if (status === 'bin') {
        let result = await this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Yes, bin it!'
        })

        if (!result.value) {
          return
        }
      }

      this.current_item.quality_control_status = status

      db.collection('project').doc(this.current_item.project_id).collection('item').doc(this.current_item.id).update({quality_control_status: status, quality_control_review_count: FieldValue.increment(1), quality_control_updated: new Date()})

      this.current_index++
    },
    async load_queue(status) {
      this.loading_queue = true

      status = status ? status : 'review'

      let query = db.collectionGroup('item').where('quality_control_status', '==', status)
      if (this.profile.role === 'admin') {
        // pass
      } else if (this.profile.team_role.role === constants.team_role.admin || this.profile.team_role.role === constants.team_role.manager) {
        query = query.where('team', '==', db.collection('team').doc(this.profile.team.id))
      } else {
        query = query.where('user', '==', db.collection('user').doc(this.profile.id))
      }

      let docs = await query.orderBy('quality_control_updated', 'desc').limit(100).get()

      let projects = {}
      let users = {}

      let items = []
      for (let doc of docs.docs) {
        let project_id = doc.ref.parent.parent.id

        if (!doc.data() || !doc.data().user) {
          console.warn('No user!', project_id, doc.data())
          continue
        }

        let uid = doc.data().user.id

        if (!projects[project_id]) {
          let project_doc = await db.collection('project').doc(project_id).get()

          if (!project_doc.data()) {
            console.warn('No project!', project_id)
            continue
          }

          let voice_id  = null
          if (project_doc.data().voice_doc) {
            voice_id = project_doc.data().voice_doc.id
          }

          projects[project_id] = {voice_id: voice_id, name: project_doc.data().name}
        }

        if (!users[uid]) {
          let user_doc = await db.collection('user').doc(uid).get()
          let email = user_doc.data().email

          users[uid] = {email: email}
        }

        let item = {
          name: doc.data().name,
          uid: uid,
          email: users[uid].email,
          created: doc.data().created,
          project_id: project_id,
          project_name: projects[project_id].name,
          id: doc.id,
          quality_control_status: doc.data().quality_control_status,
          quality_control_review_count: doc.data().quality_control_review_count,
          quality_control_updated: doc.data().quality_control_updated,
          voice_id: projects[project_id].voice_id,
          video_url: doc.data().video_url,
          variables: doc.data().variables
        }

        items.push(item)
      }

      console.log(items)

      this[status] = items

      this.loading_queue = false
    }
  },
  computed: {
    table_queue() {
      let table_queue = []
      let i = 0
      for (let item of this.review) {
        item._rowVariant = undefined
        if (i == this.current_index) {
          item._rowVariant = 'primary'
        }

        table_queue.push(item)
        i++
      }

      return table_queue
    },
    current_item() {
      if (!this.review || this.review.length === 0) {
        return null
      }

      return this.review[this.current_index]
    }
  }
}
</script>

<style scoped>

</style>
